import API from "../../../../../global/api";
import jsPDF from "jspdf";
import _ from "lodash";
import "jspdf-autotable";


export const requestAddProductionIssuance = () => {
    return {
        type: "REQUEST_ADD_PRODUCTION_ISSUANCE",
    };
};
export const successAddProductionIssuance = (data) => {
    return {
        type: "SUCCESS_ADD_PRODUCTION_ISSUANCE",
        payload: data,
    };
};
export const errorAddProductionIssuance = () => {
    return {
        type: "ERROR_ADD_PRODUCTION_ISSUANCE",
    };
};
export const AddProductionIssuanceApi = (data, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestAddProductionIssuance());
        API.post(`/productionIssuance`, data).then((res) => {
            dispatch(successAddProductionIssuance(data));
            handleVisible(res.data.message);
        }).catch((error) => {
            dispatch(errorAddProductionIssuance());
            handleDangerVisible(error.response.data.message);
        })
    };
};


export const requestGetProductionIssuance = () => {
    return {
        type: "REQUEST_GET_PRODUCTION_ISSUANCE",
    };
};
export const successGetProductionIssuance = (data) => {
    return {
        type: "SUCCESS_GET_PRODUCTION_ISSUANCE",
        payload: data,
    };
};
export const errorGetProductionIssuance = () => {
    return {
        type: "ERROR_GET_PRODUCTION_ISSUANCE",
    };
};
export const GetProductionIssuanceApi = () => {
    return (dispatch) => {
        dispatch(requestGetProductionIssuance());
        API.get(`/productionIssuance`).then((res) => {
            let getData = res.data;
            dispatch(successGetProductionIssuance(getData));
        }).catch((error) => {
            dispatch(errorGetProductionIssuance());
        })
    };
};


export const requestProductionIssuanceReport = () => {
    return {
        type: "REQUEST_PRODUCTION_ISSUANCE_REPORT",
    };
};
export const successProductionIssuanceReport = (data) => {
    return {
        type: "SUCCESS_PRODUCTION_ISSUANCE_REPORT",
        payload: data,
    };
};
export const errorProductionIssuanceReport = () => {
    return {
        type: "ERROR_PRODUCTION_ISSUANCE_REPORT",
    };
};
export const IssuanceReportApi = (payload) => {
    return (dispatch) => {
        dispatch(requestProductionIssuanceReport());
        API.post(`/productionIssuance/issuance-report`, payload).then((res) => {
            const data = res.data
            dispatch(successProductionIssuanceReport(data));
        }).catch((error) => {
            dispatch(errorProductionIssuanceReport());
        })
    };
};


export const PrintSingleProductionIssuance = (data) => {
    return (dispatch) => {
        const unit = "pt";
        const size = "A4";
        const orientation = "potrait";
        const doc = new jsPDF(orientation, unit, size);
        const title = "Production Issuance Details";
        const companyName = `${process.env.REACT_APP_COMPANY_NAME}`;
        const companyAddress = `${process.env.REACT_APP_COMPANY_ADDRESS}`;
        const companyNtn = `${process.env.REACT_APP_COMPANY_NTN}`;
        const sequenceNumber = "Issuance No: " + data.sequenceNumber;
        const issuanceDate = "Issuance Date: " + data.issuanceDate;
        const vendorName = "Vendor Name: " + data?.vendorDetails?.vendorName;
        const returnDate = `Return Date: ${data.returnDate}`;
        const orderNumber = "Order No.: " + data?.orderDetails?.orderNumber;
        const issuanceType = "Issuance Type: " + data.issuanceType;
        // const orderDeadLineDate = "Order DeadLine Date: " + data.orderDeadLineDate;
        // const manualOrderNumber = "Manual Order Number: " + data.orderNumber;

        const headers = [[
            "Sr",
            "Article Name",
            "Issuance Quantity",
            "Process Name",
            "Process Rate",
        ]];
        const prodactData = _.isEmpty(data?.orderDetails?.articleIssuanceDetails) ? [] : data?.orderDetails?.articleIssuanceDetails.map((elt, i) => [
            i + 1,
            elt.articleName,
            elt.issuanceQuantity,
            elt.processDetails.processName,
            elt.processDetails.processRate,
        ]);
        if (!_.isEmpty(prodactData)) {
            prodactData.push(["Total", "", Math.round(_.sumBy(prodactData, '2') * 100) / 100, "", Math.round(_.sumBy(prodactData, '4') * 100) / 100])
        }
        let ProductContent = {
            startY: 230,
            startX: 50,
            head: headers,
            styles: { fontSize: 11 },
            body: prodactData,
            theme: "grid",
            headStyles: { fillColor: "#2980ba" },
        };
        doc.autoTable(ProductContent);

        // doc.addImage(logo, "PNG", 40, 15, 80, 80);
        doc.text(companyName, 150, 40, 0, 20);
        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal");
        doc.text(companyAddress, 150, 58, 0, 20);
        doc.text(companyNtn, 150, 80, 0, 20);
        doc.setFontSize(14);
        doc.setFont("Times New Roman", "bold")
        doc.text(title, 240, 120);
        doc.setFontSize(12);
        doc.setFont("Times New Roman", "normal")
        doc.text(sequenceNumber, 50, 150, 0, 20);
        doc.text(issuanceDate, 330, 150, 0, 20);
        doc.text(vendorName, 50, 170, 0, 20);
        doc.text(returnDate, 330, 170, 0, 20);
        doc.text(orderNumber, 50, 190, 0, 20);
        doc.text(issuanceType, 330, 190, 0, 20);
        // doc.text(customerName, 50, 210, 0, 20);
        // doc.text(manualOrderNumber, 330, 210, 0, 20);


        doc.setProperties({ title: `Order PDF` });
        var blob = doc.output("blob");
        window.open(URL.createObjectURL(blob));
    };
};